module.exports = __webpack_public_path__ + "media/images/product_lines/travel/h3-3635318bb1806595792c0bffe3493c54.svg";